<div *ngIf="isLoading" class="spinner-overlay">
  <div class="spinner">
    <mat-spinner></mat-spinner>
  </div>
</div>

<body>
  <div class="headerContratos">
    <div class="tituloPag">
      <h3 class="subtitulo" style="font-family: 'Times New Roman', Times, serif;">Transportadores Frete Extra</h3>
    </div>
    <div class="align-right">
      <div class="icone-setting">
        <div class="icone-setting">
          <button class="btn-frete icone-setting" mat-button (click)="solicitarFrete()"><i-feather
              name="file-plus"></i-feather>Adicionar transportador</button>
        </div>
      </div>
    </div>
  </div>
  <ul>
    <table id="excel-table">
      <thead>
        <tr>
          <th>Transportador</th>
          <th colspan="3">Custos por Km</th>
          <th>Validade</th>
          <th>Editar</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let item of items; let i = index">
          <td>{{ item.transportadora }}</td>
          <td colspan="3">
            <table class="custos">
              <thead>
                <th>Modelo</th>
                <th>0-50 km</th>
                <th>51-100 km</th>
                <th>101-200 km</th>
                <th>201-500 km</th>
                <th>501-1000 km</th>
                <th>>1000 km</th>
              </thead>
             
              <tr *ngFor="let veiculo of item.veiculo;">
                <td>{{ veiculo.modelo }}</td>
                <td>{{ formatarComoMoeda(veiculo.km0a50) }}</td>
                <td>{{ formatarComoMoeda(veiculo.km51a100) }}</td>
                <td>{{ formatarComoMoeda(veiculo.km101a200) }}</td>
                <td>{{ formatarComoMoeda(veiculo.km201a500) }}</td>
                <td>{{ formatarComoMoeda(veiculo.km501a1000) }}</td>
                <td>{{ formatarComoMoeda(veiculo.km1000) }}</td>
              </tr>
            </table>
          </td>
          <td>
            {{ item.validade | date : 'dd/MM/yyyy' }}
          </td>
          <td>
            <button [disabled]="!isCarrierEnabled && !isAdminEnabled" mat-icon-button color="primary"
              aria-label="Editar" (click)="editDialog(item, i)">
              <span class="material-icons">edit</span>
            </button>
            <button [disabled]="usuarioLogado.role != '9' && usuarioLogado.role != '2'" mat-icon-button color="warn"
              aria-label="Excluir" (click)="deleteItem(item.ID, urlConsulta, query)">
              <span class="material-icons">delete</span>
            </button>
          </td>
        </tr>
      </tbody>
    </table>
  </ul>
</body>

<clr-modal [(clrModalOpen)]="dialogOpen" [clrModalSize]="'md'" class="dialog-container">
  <!-- <div> -->
  <h3 class="modal-title">CADASTRO</h3>
  <!-- <h3 class="modal-title" style="font-size: 15px;">Contact: <abbr style="color: #3b82f6; font-size: 15px;">SSBVAD</abbr>
    Phone: 55 11 4344-8947 | Mobile: +55 11
    97488-2943</h3> -->
  <!-- </div> -->
  <div class="modal-body scroll-container">
    <form class="inputs">
      <table class="table3000">
        <tr>
          <td>
            <label class="modal-label">Veículos</label>
          </td>
          <td>
            <button type="button" (click)="adicionarDailyCost()">Adicionar veiculo e custos</button>
          </td>
          <td colspan="2">
            <label class="modal-label">Transportadora</label>
          </td>
          <td>
            <!-- <input [disabled]='true' type="text" name="transportadora" [(ngModel)]="item.transportadora" class="modal-input1"> -->
            <select class="selectVehicle" name="transportadora" [(ngModel)]="item.transportadora" appendTo="body">
              <option value="-">-</option>
              <option *ngFor="let type of this.carriers" [value]="type.name">{{ type.name }}</option>
              <option value="other">Other</option>
            </select>
          </td>
          <td colspan="2">
            <label class="modal-label">Validade</label>
          </td>
          <td>
            <input type="date" name="validade" [(ngModel)]="item.validade" class="modal-input1">
          </td>
          </tr>
          
    
        
        
        <tr *ngFor="let veiculo of item.veiculo; let i = index">
          <td>
            <label class="modeloVeiculo">{{ veiculo.modelo }}</label>
            <!-- <input [disabled]='true' type="text" [name]="'modelo' + i" [(ngModel)]="veiculo.modelo"> -->
            <select *ngIf="!veiculo.modelo" [disabled]="!isAdminEnabled && !isUserEnabled" id="modelo" name="modelo"
            [(ngModel)]="veiculo.modelo" class="selectVehicle" (blur)="onFieldTouched()">
              <option value="-">-</option>
              <option *ngFor="let vehicle of typesVehicles" [value]="vehicle">{{ vehicle }}</option>
            </select>
          </td>
        <!-- <tr *ngFor="let veiculo of item.veiculo; let i = index"> -->
          <td>
            <label>0-50 km</label>
            <input type="decimal" [name]="'km0a50' + i" [(ngModel)]="veiculo.km0a50">
          </td>
          <td>
            <label>51-100 km</label>
            <input type="decimal" [name]="'km51a100' + i" [(ngModel)]="veiculo.km51a100">
          </td>
          <td>
            <label>101-200 km</label>
            <input type="decimal" [name]="'km101a200' + i" [(ngModel)]="veiculo.km101a200">
          </td>
          <td>
            <label>201-500 km</label>
            <input type="decimal" [name]="'km201a500' + i" [(ngModel)]="veiculo.km201a500">
          </td>
          <td>
            <label>501-1000 km</label>
            <input type="decimal" [name]="'km501a1000' + i" [(ngModel)]="veiculo.km501a1000">
          </td>
          <td>
            <label>>1000 km</label>
            <input type="decimal" [name]="'km1000' + i" [(ngModel)]="veiculo.km1000">
          </td>
          <td>
            <button type="button" (click)="removerDailyCost(i)">Delete</button>
          </td>
        </tr>
      </table>
      <div class="modal-div">
        <button class="modal-button" type="button" (click)="salvar2(item)">Save</button>
        <button class="modal-button" type="button" (click)="cancel()">Cancel</button>
      </div>
    </form>
  </div>
</clr-modal>

<div *ngIf="isLoading" class="spinner-overlay">
  <div class="spinner">
    <mat-spinner></mat-spinner>
  </div>
</div>